import React from 'react';
import { Box, Typography, Button, CircularProgress } from '@mui/material';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { useSnackbar } from 'notistack';
import GroceryDragLayout from './GroceryDragLayout';

const HistoryGroceryList = ({ items, loading, hasMore, onUncheck, onLoadMore, onAddItem, currentUserId }) => {
    const { enqueueSnackbar } = useSnackbar();

    const handleDragDrop = (itemId, dropZoneId) => {
        const item = items.find(i => i.id === itemId);
        if (!item) return;

        if (dropZoneId === 'restore') {
            // Add as new item to active list (keeping history)
            onAddItem(item.name, currentUserId);
            enqueueSnackbar(`Added ${item.name} to list! 📝`, { 
                variant: 'success',
                autoHideDuration: 3000
            });
        }
    };

    const emptyState = (
        <Box sx={{ textAlign: 'center', py: 6 }}>
            <Typography variant="h5" color="white" fontWeight="bold">
                No purchase history
            </Typography>
            <Typography variant="body1" color="rgba(255, 255, 255, 0.8)" sx={{ mt: 1 }}>
                Checked items will appear here
            </Typography>
        </Box>
    );

    const footer = hasMore ? (
        <Box sx={{ textAlign: 'center', mt: 3 }}>
            <Button
                variant="contained"
                onClick={onLoadMore}
                disabled={loading}
                sx={{
                    bgcolor: '#4299e1',
                    color: 'white',
                    px: 4,
                    py: 1.5,
                    borderRadius: 3,
                    fontWeight: 'bold',
                    '&:hover': {
                        bgcolor: '#3182ce'
                    }
                }}
            >
                {loading ? (
                    <>
                        <CircularProgress size={20} sx={{ mr: 1, color: 'white' }} />
                        Loading...
                    </>
                ) : (
                    'Load More'
                )}
            </Button>
        </Box>
    ) : null;

    const dropZones = [
        {
            id: 'restore',
            label: "WE'RE OUT!",
            color: '#2f855a', // Same green as PURCHASED for positive action
            hoverColor: '#48bb78',
            icon: ShoppingCartIcon
        }
    ];

    return (
        <GroceryDragLayout
            items={items}
            loading={loading && items.length === 0}
            currentUserId={currentUserId} 
            dropZones={dropZones}
            onDragDrop={handleDragDrop}
            emptyState={emptyState}
            footer={footer}
        />
    );
};

export default HistoryGroceryList;
